function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { inpayEnv } from '../env';
import { inpayLocale } from '../locale';
import apiForWeb from './api-for-web';
import { stampMediator } from '../mediator';
import { IAS_WEB_TOKEN, RESTORE } from '../constant';
function _reqStamp(_ref) {
  var path = _ref.path,
    method = _ref.method,
    _ref$useQuery = _ref.useQuery,
    useQuery = _ref$useQuery === void 0 ? false : _ref$useQuery,
    _ref$header = _ref.header,
    header = _ref$header === void 0 ? {} : _ref$header,
    _ref$body = _ref.body,
    body = _ref$body === void 0 ? {} : _ref$body;
  var commonHeader = {
    'Content-Type': 'application/x-www-form-urlencoded',
    gsid: 1
  };
  var url = "".concat(inpayEnv.STAMP_SERVER_ADDRESS).concat(path);
  var reqHeader = _objectSpread(_objectSpread({}, commonHeader), header);
  return apiForWeb.req({
    url: url,
    header: reqHeader,
    useQuery: useQuery,
    body: body,
    method: method
  });
}
function _makeSearchParams() {
  var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var searchParam = new URLSearchParams();
  Object.entries(param).filter(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      value = _ref3[1];
    return value !== undefined && value !== null;
  }).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      key = _ref5[0],
      value = _ref5[1];
    return searchParam.append(key, value);
  });
  return searchParam;
}
function _issueKrpc(_ref6) {
  var _ref6$param = _ref6.param,
    param = _ref6$param === void 0 ? {} : _ref6$param,
    _ref6$header = _ref6.header,
    header = _ref6$header === void 0 ? {} : _ref6$header;
  var isMpProcess = !!param.products;
  return _reqStamp({
    path: "/v2/issue/krpc/web".concat(isMpProcess ? '/mp' : ''),
    method: 'POST',
    body: _makeSearchParams(param),
    header: header
  });
}
function _issueArena(_ref7) {
  var _ref7$param = _ref7.param,
    param = _ref7$param === void 0 ? {} : _ref7$param,
    _ref7$header = _ref7.header,
    header = _ref7$header === void 0 ? {} : _ref7$header;
  var isMpProcess = !!param.products;
  return _reqStamp({
    path: "/v2/issue/arena/web".concat(isMpProcess ? '/mp' : ''),
    method: 'POST',
    body: _makeSearchParams(param),
    header: header
  });
}
function _issueJppc(_ref8) {
  var _ref8$param = _ref8.param,
    param = _ref8$param === void 0 ? {} : _ref8$param,
    _ref8$header = _ref8.header,
    header = _ref8$header === void 0 ? {} : _ref8$header;
  var isMpProcess = !!param.products;
  return _reqStamp({
    path: "/v2/issue/jppc/web".concat(isMpProcess ? '/mp' : ''),
    method: 'POST',
    body: _makeSearchParams(param),
    header: header
  });
}
var stampApiForWeb = {
  STAMP_STATUS_CODE: {
    ISSUED: 10,
    // 구매 트랜잭션 시작
    VERIFIED: 40,
    // 영수증 유효성 검증 완료,
    FAILED_DELEVERY: 41,
    // 아이템 지급 실패
    FINISHED: 50,
    // 아이템 지급 완료
    FINISHED_BUT_DELIVERY_REJECTED: 51,
    // 결제 완료, 아이템 지급은 정책상 거부됨.
    REFUND: 92,
    // 유저가 환불한 영수증
    ABUSERS_FINISHED: 97 // 정상적이지 않은 유저 혹은 영수증 접근
  },
  // txStatus 코드 정의 https://confluence.nexon.com/pages/viewpage.action?pageId=515912989
  isErrorTxStatus: function isErrorTxStatus(txStatus) {
    var txStatusNumber = Number(txStatus);
    var definedIssue = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, this.STAMP_STATUS_CODE.ISSUED, {
      isError: false,
      message: 'Start for payment'
    }), this.STAMP_STATUS_CODE.VERIFIED, {
      isError: false,
      message: 'allow item delivery'
    }), this.STAMP_STATUS_CODE.FINISHED, {
      isError: false,
      message: 'finished of all payment steps'
    }), this.STAMP_STATUS_CODE.FAILED_DELEVERY, {
      isError: true,
      message: 'cannot delivery from purchase.'
    }), this.STAMP_STATUS_CODE.FINISHED_BUT_DELIVERY_REJECTED, {
      isError: true,
      message: 'rejected for item payment'
    }), this.STAMP_STATUS_CODE.REFUND, {
      isError: true,
      message: 'refund receipt or invalid receipt'
    }), this.STAMP_STATUS_CODE.ABUSERS_FINISHED, {
      isError: true,
      message: 'inccorect receipt'
    });
    var error = definedIssue[txStatusNumber];
    if (error && !error.isError) {
      // 이 상태코드는 에러 아님
      return false;
    }
    return true;
  },
  issue: function issue(_ref9) {
    var _ref9$param = _ref9.param,
      param = _ref9$param === void 0 ? {} : _ref9$param,
      _ref9$header = _ref9.header,
      header = _ref9$header === void 0 ? {} : _ref9$header,
      webToken = _ref9.webToken;
    var market = inpayLocale.getMarketFromWebToken(webToken);
    switch (market) {
      case inpayLocale.MARKET_ENUM.KRPC:
        return _issueKrpc({
          param: param,
          header: header
        });
      case inpayLocale.MARKET_ENUM.JPPC:
        return _issueJppc({
          param: param,
          header: header
        });
      default:
        return _issueArena({
          param: param,
          header: header
        });
    }
  },
  getStatus: function getStatus(_ref10) {
    var _ref10$param = _ref10.param,
      param = _ref10$param === void 0 ? {} : _ref10$param,
      _ref10$header = _ref10.header,
      header = _ref10$header === void 0 ? {} : _ref10$header;
    return _reqStamp({
      path: '/v2/stamp/status',
      method: 'POST',
      header: header,
      body: _makeSearchParams(_objectSpread(_objectSpread({}, param), {}, {
        token_type: IAS_WEB_TOKEN
      }))
    });
  },
  getArenaCurrency: function getArenaCurrency(_ref11) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _ref11$param, param, _ref11$header, header, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref11$param = _ref11.param, param = _ref11$param === void 0 ? {} : _ref11$param, _ref11$header = _ref11.header, header = _ref11$header === void 0 ? {} : _ref11$header;
            _context.next = 3;
            return _reqStamp({
              path: '/v2/user/currency/arena',
              method: 'POST',
              header: header,
              body: _makeSearchParams(param)
            });
          case 3:
            data = _context.sent;
            return _context.abrupt("return", data.currency);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  /*
   * 결제 이후 지급 실패 복구를 위한 vendor 복구 API
   * @param {string} gid - 게임 아이디
   * @param {string} market - krpc, jppc, arena 등
   * @param {string} webToken - 웹 토큰
   * @returns {Promise} - Promise 객체
   */
  restoreVendor: function restoreVendor(_ref12) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var gid, market, webToken, data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            gid = _ref12.gid, market = _ref12.market, webToken = _ref12.webToken;
            _context2.next = 3;
            return _reqStamp({
              path: "/v2/restore/".concat(market.toLowerCase(), "/mp"),
              method: 'POST',
              header: {
                gid: gid
              },
              body: _makeSearchParams({
                token: webToken,
                token_type: IAS_WEB_TOKEN,
                delivery_type: RESTORE
              })
            });
          case 3:
            data = _context2.sent;
            return _context2.abrupt("return", data);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  /*
   * 결제 이후 지급 실패 복구를 위한 stamp 복구 API, vendor 복구 이후에 호출되 어야함
   * @param {string} gid - 게임 아이디
   * @param {string} webToken - 웹 토큰
   * @returns {Promise} - Promise 객체
   */
  restoreStamp: function restoreStamp(_ref13) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var gid, webToken, data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            gid = _ref13.gid, webToken = _ref13.webToken;
            _context3.next = 3;
            return _reqStamp({
              path: '/v2/restore/mp',
              method: 'POST',
              header: {
                gid: gid
              },
              body: _makeSearchParams({
                token: webToken,
                token_type: IAS_WEB_TOKEN
              })
            });
          case 3:
            data = _context3.sent;
            return _context3.abrupt("return", data);
          case 5:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }))();
  }
};
stampMediator.stamp = stampApiForWeb;
export default stampApiForWeb;